import dayjs from 'dayjs';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import { createCalendarBlockRoute, createCalendarBlockTimeRoute, eventsKey } from '@features/enterpriseEvents';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';

type useCreateInterviewBlockTimeProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};


export const useCreateInterviewBlockTime = ({
  setErrorText = () => { },
}: useCreateInterviewBlockTimeProps) => {
  const client = useQueryClient();

  const { mutate: createInterviewBlockTime, isLoading: isCreatingInterviewBlockTime } =
    useMutation({
      mutationFn: (variables: {
        start_time: number;
        ends_on?: string | number | undefined;
        ends_type?: number | undefined;
        original_days?: string | undefined;
        days?: string | undefined;
        end_time: number;
        eventDate: string;
        time_period: number | string;
        job_ids?: string;
        company_id?: number
      }) =>
        axiosInstance
          .post(createCalendarBlockTimeRoute, variables)
          .then((res) => res.data),
      onSuccess: (data, req) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          client.invalidateQueries([eventsKey]);
          client.invalidateQueries([profileKey]);
          setErrorText('');
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    createInterviewBlockTime,
    isCreatingInterviewBlockTime,
  };
};
